import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  getUniversityList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report/estimatePlan/findUniversityQueryList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report/estimatePlan/save`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSpecialityList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report/estimatePlan/findProfessionList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      try {
        axios({
          method: "post",
          url: "/report/estimatePlan/findSchemeList",
          data: params
        }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      } catch (e) {
        console.log(e);
      }
    });
  },
  getSchemeDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/estimatePlan/findSchemeUniversity`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findBasicConfigData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/estimatePlan/findBasicConfigData`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSchemeDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/estimatePlan/findSchemeUniversity`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getDictionary({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/fwxtdictionary/findAllItemByTypeCode",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  saveOrUpdateField({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/configPlanField/saveOrUpdateField`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  selectInitialSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report/finalPlan/selectLastProgramList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSchemeDetailForNewPlanByLastStep({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/estimatePlan/selectProgramInfoLast`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
};
